import { AuthenticationService } from './../../service/auth/authentication.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WestnetzOnlyAccessGuard implements CanActivate {
    private authenticationService = inject(AuthenticationService);

    canActivate(
        _next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.authenticationService.isVnb(this.authenticationService.user);
    }
}
